import { render, staticRenderFns } from "./SaveProduct.vue?vue&type=template&id=565853ae"
import script from "./SaveProduct.vue?vue&type=script&lang=js"
export * from "./SaveProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports